export default __webpack_public_path__ + "static/AberdeenOilcats-d3c6005cc612180214a35cad2e1fbf1e.jpg";